import { getHublessConfig } from 'unified-navigation-ui/config';
import loadDependentScripts from 'unified-navigation-ui/js/utils/loadDependentScripts';
import { setLangKey } from '../../utils/getLangKey';
import { configureStore } from '../../utils/configureStore';
import { Provider } from 'react-redux';
import { getOrAddUtilityBannersContainer, getOrAddGlobalToolbarContainer, removeNavPlaceholders } from '../../utils/globalToolbarUtils';
import hydrateStore from '../../reducers/utils/hydrateStore';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'foundations-theming/components/ThemeProvider';
import { HublessNav } from '../components/HublessNav';
import { updatePageWidthForVerticalNav } from '../../components/VerticalNav/utils/updatePageWidthForVerticalNav';
import { jsx as _jsx } from "react/jsx-runtime";
export function setupTranslations(resp) {
  const {
    translations,
    user
  } = resp;
  const {
    displayLanguage
  } = user;
  setLangKey(displayLanguage);
  translations['LANG_FROM_NAVCONFIG'] = displayLanguage;
}
export function renderHublessNav(callback) {
  function configCallback(resp) {
    setupTranslations(resp);
    const store = configureStore(hydrateStore(resp));
    getOrAddUtilityBannersContainer();
    const container = getOrAddGlobalToolbarContainer();
    const root = createRoot(container);
    root.render( /*#__PURE__*/_jsx(ThemeProvider, {
      children: /*#__PURE__*/_jsx(Provider, {
        store: store,
        children: /*#__PURE__*/_jsx(HublessNav, {})
      })
    }));
    updatePageWidthForVerticalNav({
      isVerticalNavEnabled: false
    });
    removeNavPlaceholders();
    loadDependentScripts();
    callback(store);
  }
  return getHublessConfig(configCallback);
}